import { useFormikContext } from 'formik'
import { useEffect } from 'react'

import {
  AdvancedSearchFormType,
  TriggerPrimaryTypeChangeProps,
} from './interface'

export function TriggerPrimaryTypeChange({
  primaryType,
  orderBy,
  secondaryType,
  showAdvancedSearch,
}: TriggerPrimaryTypeChangeProps) {
  const { setFieldValue } = useFormikContext<AdvancedSearchFormType>()

  useEffect(() => {
    if (showAdvancedSearch) {
      setFieldValue('orderBy', orderBy)
      setFieldValue('secondaryType', secondaryType)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [primaryType, showAdvancedSearch])

  return null
}
